import { Controller } from "stimulus";
import OpInview from './../components/opInview/opInview';
import anime from 'animejs';

export default class extends Controller {
    static targets = [ 'h'];

    initialize() {
        this.activate = this.activate.bind(this);
    }

    connect() {
        // let words = this.hTarget.textContent.trim().split(" ");
        // let content = '';
        // for (let i = 0; i < words.length; i++) {
        //     content += `<span class='word'>${words[i]}</span> `;
        // }
        // this.hTarget.innerHTML = content;
        new OpInview(this.element, {
            start: 0.2,
            end: 0.8,
            activateCallback: this.activate,
        });
    }

    activate() {
        // this.animationText = anime.timeline({
        //     autoplay: true
        // }).add({
        //     targets: this.hTarget.querySelectorAll('.word'),
        //     opacity: [0, 1],
        //     translateY: {
        //         value: [20, 0],
        //         easing: "easeOutExpo",
        //     },
        //     easing: "easeOutQuad",
        //     duration: 1000,
        //     // duration: function() { return anime.random(1000, 1400); },
        //     delay: function(el, i) {
        //         return 100 * (i+1)
        //     },
        // });

        // if (this.subTarget) {
        //     this.animationText.add({
        //         targets: this.subTarget,
        //         opacity: {
        //             value: [0, 1],
        //             easing: "easeInOutQuad",
        //         },
        //         translateY: [50, 0],
        //         easing: "easeOutQuad",
        //         duration: 1200,
        //         offset: 0,
        //         delay: 800
        //     });
        // }
    }
}


// WEBPACK FOOTER //
// ./mysite/resources/js/controllers/header_controller.js